import React from 'react';

type SvgPlusProps = {
  width?: number;
  height?: number;
};

export const PlusIcon = ({ width = 17, height = 16 }: SvgPlusProps): JSX.Element => (
  <svg width={width} height={height} viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    {/* eslint-disable-next-line i18next/no-literal-string */}
    <title>Plus Icon</title>
    <path
      d='M8.55.617v14.857M1.12 8h14.858'
      stroke='#000'
      strokeWidth='1.143'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
